var React = require('react');

function MailboxInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"mailbox.inline"),React.createElement("g",{"id":"e26111d0-66da-424b-a00b-7a0a12aed8bf","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b357289e-dc84-42b7-976b-261e1967f738","data-name":"Layer 1"},React.createElement("g",{"id":"eda363d4-46e6-4b89-a50d-8cc212136ed7","data-name":"mailbox.inline"},React.createElement("path",{"d":"M13,11.9H23.15V23.05m-10.9,0V38M17,38V23.05M1.29,4.8H6.61v-4H1.29ZM6.61,16.41V.81M16.86,23.05H.81V15.16a8,8,0,0,1,8-8H20.35m8,15.91h-16V15.16a8,8,0,1,1,16,0Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

MailboxInline.defaultProps = {"viewBox":"0 0 29.18 38.79"};

module.exports = MailboxInline;

MailboxInline.default = MailboxInline;
